import React from 'react'
import PropTypes from 'prop-types'
import { Button, Box, Flex, Copy, Icon } from '@elparking/components'

import { Container } from '../ui'
import { FormattedMessage } from 'react-intl'

import ErrorMessage from './ErrorMessage'

const Error = ({ onBack, error }) => (
    <Container key='error'>
        <Flex>
            <Box pr='1em' pt='2em'>
                <Icon type='warning-line' color='red' size='xxLarge' />
            </Box>
            <Box>
                <Copy fontColor='gray' padding='0' fontSize='xSmall' fontWeight='regular' transform='uppercase'>
                    <FormattedMessage defaultMessage='Se ha producido un error'/>
                </Copy>
                <Copy fontColor='red' fontSize='xxLarge' fontWeight='regular' padding='0.3em 0'>
                    <ErrorMessage error={error} />
                </Copy>
            </Box>
        </Flex>
        <Box mt='2em' textAlign='center'>
            <img src='/images/fine-portal/error.svg' width='200px' />
        </Box>
        <Box mt='3em'>
            <Button width='100%' onClick={onBack}>
                <Icon type='left' color='white' /> <FormattedMessage defaultMessage='Volver' />
            </Button>
        </Box>
    </Container>
)

Error.propTypes = {
    onBack: PropTypes.func.isRequired,
    error: PropTypes.object.isRequired,
}

export default Error
